// Sakura PDP Clone — interactions
(function () {
  'use strict';

  // ===== ANNOUNCEMENT SLIDER (horizontal slide loop, 3500ms) =====
  const annTrack = document.getElementById('annTrack');
  if (annTrack) {
    const annSlideEls = annTrack.querySelectorAll('.announcement__slide');
    const realCount = annSlideEls.length - 1; // last is clone of first
    let annIdx = 0;
    const advance = () => {
      annIdx += 1;
      annTrack.style.transition = 'transform 0.7s cubic-bezier(0.32, 0.72, 0, 1)';
      annTrack.style.transform = `translateX(-${annIdx * 100}%)`;
      if (annIdx === realCount) {
        // After transition ends, jump back to 0 without animation
        setTimeout(() => {
          annTrack.style.transition = 'none';
          annTrack.style.transform = 'translateX(0)';
          annIdx = 0;
        }, 720);
      }
    };
    setInterval(advance, 3500);
  }

  // ===== GALLERY (track + swipe + arrows + thumb sync) =====
  const track = document.getElementById('galleryTrack');
  const viewport = document.getElementById('galleryViewport');
  const slides = document.querySelectorAll('.gallery__slide');
  const thumbs = document.querySelectorAll('.gallery__thumb');
  const arrows = document.querySelectorAll('.gallery__arrow');
  const slideCount = slides.length;
  let activeIndex = 0;

  function setSlide(i) {
    activeIndex = Math.max(0, Math.min(slideCount - 1, i));
    if (track) track.style.transform = `translateX(-${activeIndex * 100}%)`;
    slides.forEach((s, idx) => s.classList.toggle('is-active', idx === activeIndex));
    thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === activeIndex));
    slides.forEach((s, idx) => {
      const v = s.querySelector('video');
      if (!v) return;
      if (idx === activeIndex) v.play().catch(() => {}); else v.pause();
    });
  }
  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('click', () => setSlide(parseInt(thumb.dataset.i, 10) || idx));
  });
  arrows.forEach(arrow => {
    arrow.addEventListener('click', () => setSlide(activeIndex + parseInt(arrow.dataset.dir, 10)));
  });

  // Swipe/drag
  if (track && viewport) {
    let startX = 0, dx = 0, dragging = false, vw = 0;
    const onDown = (e) => {
      dragging = true;
      startX = (e.touches ? e.touches[0].clientX : e.clientX);
      dx = 0;
      vw = viewport.getBoundingClientRect().width;
      track.classList.add('is-dragging');
    };
    const onMove = (e) => {
      if (!dragging) return;
      const x = (e.touches ? e.touches[0].clientX : e.clientX);
      dx = x - startX;
      track.style.transform = `translateX(calc(-${activeIndex * 100}% + ${dx}px))`;
    };
    const onUp = () => {
      if (!dragging) return;
      track.classList.remove('is-dragging');
      const threshold = vw * 0.15;
      if (dx > threshold && activeIndex > 0) setSlide(activeIndex - 1);
      else if (dx < -threshold && activeIndex < slideCount - 1) setSlide(activeIndex + 1);
      else setSlide(activeIndex);
      dragging = false; dx = 0;
    };
    viewport.addEventListener('mousedown', onDown);
    viewport.addEventListener('touchstart', onDown, { passive: true });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchend', onUp);
    viewport.tabIndex = 0;
    viewport.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') setSlide(activeIndex - 1);
      else if (e.key === 'ArrowRight') setSlide(activeIndex + 1);
    });
  }

  // ===== VARIANT SELECTORS =====
  document.querySelectorAll('[data-variant]').forEach(group => {
    const items = group.querySelectorAll('.variant__swatch, .variant__pill');
    items.forEach(item => {
      item.addEventListener('click', () => {
        items.forEach(i => i.classList.remove('is-active'));
        item.classList.add('is-active');
        const label = item.dataset.label;
        if (label) {
          const el = document.getElementById('colorLabel');
          if (el) el.textContent = label;
        }
      });
    });
  });

  // ===== COMPARE SLIDERS (Pointer Events + autoplay tease on scroll-in) =====
  document.querySelectorAll('.compare-slider').forEach(slider => {
    const handle = slider.querySelector('.compare-slider__handle');
    const afterWrap = slider.querySelector('.compare-slider__after-wrap');
    if (!handle || !afterWrap) return;
    let activePointerId = null;
    let userInteracted = false;
    let autoplayTimers = [];

    const applyPct = (pct) => {
      handle.style.left = pct + '%';
      afterWrap.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    };

    const setPos = (clientX) => {
      const rect = slider.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(2, Math.min(98, pct));
      applyPct(pct);
    };

    const stopAutoplay = () => {
      userInteracted = true;
      slider.classList.remove('is-autoplay');
      autoplayTimers.forEach(clearTimeout);
      autoplayTimers = [];
    };

    slider.style.touchAction = 'pan-y';
    slider.style.cursor = 'grab';
    applyPct(50);

    slider.addEventListener('pointerdown', (e) => {
      stopAutoplay();
      activePointerId = e.pointerId;
      slider.setPointerCapture(e.pointerId);
      slider.style.cursor = 'grabbing';
      setPos(e.clientX);
      e.preventDefault();
    });
    slider.addEventListener('pointermove', (e) => {
      if (activePointerId !== e.pointerId) return;
      setPos(e.clientX);
    });
    const release = () => {
      if (activePointerId === null) return;
      try { slider.releasePointerCapture(activePointerId); } catch (_) {}
      activePointerId = null;
      slider.style.cursor = 'grab';
    };
    slider.addEventListener('pointerup', release);
    slider.addEventListener('pointercancel', release);
    slider.addEventListener('lostpointercapture', release);
    slider.addEventListener('pointerenter', stopAutoplay);

    // Keyboard accessibility
    handle.setAttribute('tabindex', '0');
    handle.setAttribute('role', 'slider');
    handle.setAttribute('aria-label', 'Comparison slider');
    handle.addEventListener('keydown', (e) => {
      const current = parseFloat(handle.style.left) || 50;
      if (e.key === 'ArrowLeft') { stopAutoplay(); applyPct(Math.max(2, current - 4)); e.preventDefault(); }
      if (e.key === 'ArrowRight') { stopAutoplay(); applyPct(Math.min(98, current + 4)); e.preventDefault(); }
    });

    // Autoplay tease: when slider enters viewport, slide 50→85→15→50 to hint interactivity
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || userInteracted) return;
          io.unobserve(slider);
          slider.classList.add('is-autoplay');
          const steps = [
            [400, 85],
            [2000, 15],
            [3600, 50],
            [5200, null], // cleanup
          ];
          steps.forEach(([delay, pct]) => {
            autoplayTimers.push(setTimeout(() => {
              if (userInteracted) return;
              if (pct === null) slider.classList.remove('is-autoplay');
              else applyPct(pct);
            }, delay));
          });
        });
      }, { threshold: 0.45 });
      io.observe(slider);
    }
  });

  // ===== COMPARE CAROUSEL CONTROLS (mobile only — scroll-snap nav) =====
  (() => {
    const grid = document.querySelector('.compare-grid');
    const controls = document.querySelector('.compare-carousel-controls');
    if (!grid || !controls) return;
    const cards = [...grid.querySelectorAll('.compare-card')];
    const prevBtn = controls.querySelector('[data-direction="prev"]');
    const nextBtn = controls.querySelector('[data-direction="next"]');
    const currentEl = controls.querySelector('.compare-carousel-current');
    const totalEl = controls.querySelector('.compare-carousel-total');
    if (!cards.length || !prevBtn || !nextBtn) return;
    totalEl.textContent = cards.length;

    const isMobile = () => window.matchMedia('(max-width: 743.98px)').matches;

    const currentIndex = () => {
      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
      const step = cardWidth + gap;
      return Math.round(grid.scrollLeft / step);
    };

    const updateUI = () => {
      const i = Math.max(0, Math.min(cards.length - 1, currentIndex()));
      currentEl.textContent = i + 1;
      prevBtn.disabled = i <= 0;
      nextBtn.disabled = i >= cards.length - 1;
    };

    const scrollToIndex = (i) => {
      const clamped = Math.max(0, Math.min(cards.length - 1, i));
      const target = cards[clamped];
      if (!target) return;
      const left = target.offsetLeft - grid.offsetLeft;
      grid.scrollTo({ left, behavior: 'smooth' });
    };

    prevBtn.addEventListener('click', () => scrollToIndex(currentIndex() - 1));
    nextBtn.addEventListener('click', () => scrollToIndex(currentIndex() + 1));

    let rafId = null;
    grid.addEventListener('scroll', () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateUI);
    }, { passive: true });

    window.addEventListener('resize', () => {
      controls.style.display = isMobile() ? '' : 'none';
      updateUI();
    });

    updateUI();
  })();

  // ===== HEADER auto-hide on scroll-down, show on scroll-up =====
  const siteHeader = document.getElementById('site-header');
  if (siteHeader) {
    let lastY = window.scrollY;
    let ticking = false;
    const onScrollHeader = () => {
      const y = window.scrollY;
      const goingDown = y > lastY;
      if (y > 200 && goingDown) {
        siteHeader.classList.add('is-hidden');
      } else {
        siteHeader.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(onScrollHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  // ===== STICKY ATC — always visible on desktop, after scroll on mobile =====
  const stickyAtc = document.getElementById('stickyAtc');
  if (stickyAtc) {
    const update = () => {
      const isDesktop = window.innerWidth >= 990;
      if (isDesktop) {
        stickyAtc.classList.add('is-visible');
        return;
      }
      const product = document.querySelector('.product');
      if (!product) return;
      const rect = product.getBoundingClientRect();
      stickyAtc.classList.toggle('is-visible', rect.bottom < 100);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // ===== TECH CALLOUTS — SVG underline draw-in on intersect =====
  if ('IntersectionObserver' in window) {
    const techIO = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          // small stagger for visual rhythm
          const order = Array.from(document.querySelectorAll('.tech-callout')).indexOf(entry.target);
          setTimeout(() => entry.target.classList.add('is-revealed'), order * 120);
          techIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('.tech-callout').forEach(c => techIO.observe(c));
  } else {
    document.querySelectorAll('.tech-callout').forEach(c => c.classList.add('is-revealed'));
  }

  // ===== TRANSFORM STAT CIRCLES — gold ring sweep + count-up =====
  const animateStatCircle = (circle) => {
    const target = parseInt(circle.dataset.pct, 10) || 0;
    const numEl = circle.querySelector('.transform-stat__pct');
    const targetDeg = target * 3.6;
    const duration = 1500;
    const start = performance.now();
    const tick = (t) => {
      const elapsed = t - start;
      const progress = Math.min(1, elapsed / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      circle.style.setProperty('--pct', (targetDeg * eased) + 'deg');
      if (numEl) numEl.textContent = Math.round(target * eased) + '%';
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  if ('IntersectionObserver' in window) {
    const circleIO = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateStatCircle(entry.target);
          circleIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.transform-stat__circle').forEach(c => circleIO.observe(c));
  } else {
    document.querySelectorAll('.transform-stat__circle').forEach(animateStatCircle);
  }

  // ===== VIEWPORT-BASED VIDEO PLAY (play only when in view) =====
  if ('IntersectionObserver' in window) {
    const videoIO = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const v = entry.target;
        if (entry.isIntersecting) {
          const p = v.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    document.querySelectorAll('video[data-viewport-play]').forEach(v => videoIO.observe(v));
  } else {
    document.querySelectorAll('video[data-viewport-play]').forEach(v => v.play().catch(() => {}));
  }

  // ===== SCROLL REVEAL (IntersectionObserver) =====
  // Auto-tag section headings and key content blocks
  const revealSelectors = [
    '.section-heading',
    '.section-sub',
    '.s-toning__list',
    '.s-transform__media',
    '.s-compare__grid',
    '.s-tech__grid',
    '.s-experts__list',
    '.costs-block',
    '.s-specs__grid',
    '.s-vs__cols',
    '.s-howto__steps',
    '.faq-list',
    '.s-vtest__grid',
    '.bestsellers-track',
    '.aboutcta-block'
  ];
  revealSelectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => el.classList.add('reveal'));
  });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible'));
  }

  // ===== FAQ accordion (single-open) =====
  document.querySelectorAll('.faq-list .faq-item').forEach(item => {
    const btn = item.querySelector('.faq-item__summary');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const open = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.faq-item').forEach(sibling => {
        sibling.classList.remove('is-open');
        const sbtn = sibling.querySelector('.faq-item__summary');
        if (sbtn) sbtn.setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ===== VIDEO TESTIMONIAL MODAL =====
  const vtestModal = document.getElementById('vtestModal');
  const vtestModalImg = document.getElementById('vtestModalImg');
  const vtestClose = document.getElementById('vtestClose');
  document.querySelectorAll('[data-vtest]').forEach(card => {
    card.addEventListener('click', () => {
      if (!vtestModal || !vtestModalImg) return;
      vtestModalImg.src = card.dataset.poster || '';
      vtestModal.classList.add('is-open');
      vtestModal.setAttribute('aria-hidden', 'false');
    });
  });
  const closeVtest = () => {
    if (!vtestModal) return;
    vtestModal.classList.remove('is-open');
    vtestModal.setAttribute('aria-hidden', 'true');
    if (vtestModalImg) vtestModalImg.src = '';
  };
  if (vtestClose) vtestClose.addEventListener('click', closeVtest);
  if (vtestModal) vtestModal.addEventListener('click', (e) => { if (e.target === vtestModal) closeVtest(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeVtest(); });

  // ===== ATC button → flash feedback =====
  document.querySelectorAll('.product-info__atc, .sticky-atc__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const original = btn.innerHTML;
      btn.innerHTML = '<span>✓ Added</span>';
      setTimeout(() => { btn.innerHTML = original; }, 1400);
    });
  });

})();
